export const CommonChallenges = () => {
  const challenges = [
    {
      icon: 'ri-tools-fill',
      title: 'Deferred Maintenance',
      problem: 'Years of deferred maintenance have created a long list of needed repairs and capital improvements.',
      solution: 'We buy properties as-is and have the resources to handle extensive renovation projects.'
    },
    {
      icon: 'ri-team-fill',
      title: 'Management Issues',
      problem: 'Poor management has led to tenant problems, low occupancy, or operational inefficiencies.',
      solution: 'We specialize in turning around underperforming properties with professional management.'
    },
    {
      icon: 'ri-money-dollar-circle-fill',
      title: 'Below-Market Rents',
      problem: 'Rents are significantly below market, but raising them requires capital investment and time.',
      solution: 'We factor in future rent potential and can close quickly without waiting for rent increases.'
    },
    {
      icon: 'ri-building-fill',
      title: 'Aging Infrastructure',
      problem: 'Building systems (HVAC, plumbing, electrical) are outdated and need replacement.',
      solution: 'We have experience with major building system upgrades and factor these costs into our offers.'
    },
    {
      icon: 'ri-group-fill',
      title: 'Partnership Disputes',
      problem: 'Co-owners disagree on property management, capital improvements, or exit strategy.',
      solution: 'We can buy out one or all partners, providing a clean exit for everyone involved.'
    },
    {
      icon: 'ri-file-damage-fill',
      title: 'Estate Situations',
      problem: 'Inherited property with multiple heirs, probate issues, or need for quick liquidation.',
      solution: 'We work with estates and heirs to provide fair valuations and smooth transactions.'
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-gray-50 to-gray-100">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-6 text-gray-900">
            Common Mid-Rise Property Challenges
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Mid-rise apartment buildings often come with complex challenges. We have the expertise and resources to handle any situation.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {challenges.map((challenge, index) => (
            <div key={index} className="bg-white rounded-xl p-8 shadow-md hover:shadow-xl transition-all duration-300">
              <div className="flex items-start mb-6">
                <div className="w-14 h-14 flex items-center justify-center bg-red-500 text-white rounded-lg mr-4 flex-shrink-0">
                  <i className={`${challenge.icon} text-2xl`}></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-900">{challenge.title}</h3>
              </div>
              <div className="mb-6">
                <h4 className="font-semibold text-red-600 mb-2">The Challenge:</h4>
                <p className="text-gray-600 leading-relaxed">{challenge.problem}</p>
              </div>
              <div className="border-t border-gray-200 pt-6">
                <h4 className="font-semibold text-teal-600 mb-2">Our Solution:</h4>
                <p className="text-gray-700 leading-relaxed">{challenge.solution}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-gradient-to-br from-teal-500 to-cyan-600 rounded-2xl p-8 md:p-12 text-white text-center">
          <h3 className="text-3xl font-bold mb-6">Facing One of These Challenges?</h3>
          <p className="text-xl mb-8 text-white/95 max-w-3xl mx-auto leading-relaxed">
            Don't let property challenges keep you from moving forward. We've successfully acquired hundreds of mid-rise properties with complex issues. Let us provide a solution for your situation.
          </p>
          <a 
            href="#get-offer" 
            className="whitespace-nowrap inline-block bg-white text-teal-600 px-8 py-4 rounded-lg text-lg font-semibold hover:bg-gray-100 transition-all duration-300 shadow-lg hover:shadow-xl cursor-pointer"
          >
            Discuss Your Situation
          </a>
        </div>
      </div>
    </section>
  );
};